import VerifiedIco from "../../assets/VerifiedIco.png";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/footer.component";
import { ExcentSubmitButton2 } from "../activeProfiling/activeProfiling.styles";

export const SuccessScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const iframeKey = searchParams.get("key");
  const valuationId = searchParams.get("valuation_uid");
  const qaTesting = searchParams.get("qa_testing");

  const handleSeeValuation = () => {
    navigate(`/modelUDA?key=${iframeKey}&valuation_uid=${valuationId}`);
  };

  const handleGoToStart = () => {
    navigate(`/?key=${iframeKey}`);
  };
  return (
    <main
      className="flex flex-col justify-center items-center w-full h-full font-roboto parent-container"
      style={{ boxSizing: "border-box" }}
    >
      <article
        style={{ boxSizing: "border-box", display: "block", margin: "auto" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: "1.5em",
          }}
        >
          <img
            className="h-8 w-8"
            src={VerifiedIco}
            alt="Logo con chequeo positivo"
          />
          <span className="text-center space-y-5">
            <h1 className="text-4xl text-[#212632] font-bold">
              ¡Has llegado al final!
              <br />
              Ya puedes ver la valoración en tu correo.
            </h1>
            <h3 className="text-[#747D93] font-bold">
              Haz clic en el enlace que te hemos enviado a tu correo para
              acceder a toda la información de interés relacionada con tu
              activo.
            </h3>
          </span>
          <ExcentSubmitButton2 type="button" onClick={handleGoToStart}>
            Realizar otra valoración
          </ExcentSubmitButton2>
        </div>
        {qaTesting && (
          <button
            type="button"
            className="border border-[#DE0E48] bg-[#DE0E48] hover:bg-[#9E0A33] hover:border-[#9E0A33] tablet:rounded-full rounded-lg tablet:w-60 w-full py-3"
            onClick={() => handleSeeValuation()}
          >
            <span className="text-white">Ver valoración</span>
          </button>
        )}
      </article>
      <Footer />
    </main>
  );
};

export default SuccessScreen;
